export default class SmscodeMask {
    smscode() {
        return '999999';
    }
}
